// Dependencies
import React, { useState } from "react";
import CloseIcon from "prodigio-icons/web/outlined/Close";

// Components
import Enunciation from "components/Enunciation";
import Button from "components/Button";

// Styles
import {
    BookletModalContainer,
    BookletModalContent,
    BookletModalTitle,
    BookletModalHeader,
    Divider,
    BookletModalActionsWrapper,
    BookletModalCloseIconWrapper
} from "./styles";

// Services
import api from "services/api";
import slugify from "helpers/slugify";

// Utils
import { IModalActions } from "store/interfaces/IModal";

interface IBookletModalProps {
    data: {
        linkHTML: string;
        title: string;
        content?: string;
        id?: number;
        handleCloseClick?: () => void;
    };
    modalActions: IModalActions;
}

const BookletModal = ({ data, modalActions }: IBookletModalProps) => {
    const [isMakingDownload, setIsMakingDownload] = useState(false);

    const handleDownload = async () => {
        if (!!data.id) {
            setIsMakingDownload(true);

            api.get(`/student/material/${data.id}/report`, {
                responseType: "blob"
            })
                .then((blob) => {
                    new File([blob.data], "file");

                    const url = window.URL.createObjectURL(blob.data);

                    const fakeLink = document.createElement("a");

                    fakeLink.href = url;

                    fakeLink.download = `${slugify(data.title)}.pdf`;

                    document.body.appendChild(fakeLink);

                    fakeLink.click();

                    fakeLink.remove();

                    setIsMakingDownload(false);
                })
                .catch(() => {
                    setIsMakingDownload(false);
                });
        }
    };

    const handleClick = () => {
        if (!!data.handleCloseClick) {
            data.handleCloseClick();
        }

        modalActions.closeModal();
    };

    return (
        <BookletModalContainer>
            <BookletModalHeader>
                <BookletModalTitle>{data.title}</BookletModalTitle>

                <BookletModalActionsWrapper>
                    {!data?.linkHTML && !!data?.content && (
                        <Button variant="info" disabled={isMakingDownload} isLoading={isMakingDownload} onClick={handleDownload}>
                            Imprimir
                        </Button>
                    )}

                    <BookletModalCloseIconWrapper data-test-id="close-modal-button" onClick={handleClick}>
                        <CloseIcon width="12" height="12" />
                    </BookletModalCloseIconWrapper>
                </BookletModalActionsWrapper>
            </BookletModalHeader>

            <Divider />

            {!!data?.linkHTML && (
                <BookletModalContent>
                    <iframe allowFullScreen src={data.linkHTML} frameBorder="0" title={data.title}>
                        Seu navegador não suporta carregar esse conteúdo.
                    </iframe>
                </BookletModalContent>
            )}

            {!data?.linkHTML && !!data?.content && <Enunciation enunciation={data.content} />}

            {!data?.linkHTML && !data?.content && <p>Conteúdo não encontrado.</p>}
        </BookletModalContainer>
    );
};

export default BookletModal;
